import { TestDefinition, QuestionType } from '../../types';

export const TESTS_FUNCIONALIDAD: TestDefinition[] = [
  {
    id: 'gaf',
    code: 'GAF',
    name: 'Global Assessment of Functioning',
    category: 'Functioning',
    description: 'A global functioning assessment scale (0-100). Considers psychological, social and occupational functioning. Part of DSM-IV. Single score with detailed descriptors for each range.',
    questions: [
      {
        id: 'gaf_score',
        text: 'Select the patient\'s global level of functioning',
        type: QuestionType.LIKERT,
        options: [
          { label: '91-100: Superior functioning in a wide range of activities', value: 95 },
          { label: '81-90: Absent or minimal symptoms, good functioning', value: 85 },
          { label: '71-80: If symptoms are present, they are transient and expectable reactions', value: 75 },
          { label: '61-70: Some mild symptoms or some difficulty in functioning', value: 65 },
          { label: '51-60: Moderate symptoms or moderate difficulty in functioning', value: 55 },
          { label: '41-50: Serious symptoms or serious impairment in functioning', value: 45 },
          { label: '31-40: Some impairment in reality testing or communication, or major impairment', value: 35 },
          { label: '21-30: Behavior influenced by delusions/hallucinations or serious impairment', value: 25 },
          { label: '11-20: Some danger of hurting self or others, or inability to maintain minimum hygiene', value: 15 },
          { label: '1-10: Persistent danger of severely hurting self or others', value: 5 }
        ]
      }
    ],
    interpretations: [
      { min: 91, max: 100, label: 'Superior Functioning', color: 'bg-green-100 text-green-800' },
      { min: 81, max: 90, label: 'Good Functioning', color: 'bg-green-50 text-green-700' },
      { min: 71, max: 80, label: 'Adequate Functioning', color: 'bg-yellow-50 text-yellow-700' },
      { min: 61, max: 70, label: 'Mild-Moderate Difficulty', color: 'bg-yellow-100 text-yellow-800' },
      { min: 51, max: 60, label: 'Moderate Difficulty', color: 'bg-orange-100 text-orange-800' },
      { min: 41, max: 50, label: 'Serious Difficulty', color: 'bg-orange-200 text-orange-900' },
      { min: 31, max: 40, label: 'Major Impairment', color: 'bg-red-100 text-red-800' },
      { min: 21, max: 30, label: 'Serious Impairment', color: 'bg-red-200 text-red-900' },
      { min: 11, max: 20, label: 'Very Serious Impairment', color: 'bg-red-300 text-red-950' },
      { min: 1, max: 10, label: 'Persistent Danger', color: 'bg-red-400 text-white' }
    ]
  }
];
